import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ConsentPromptV2 from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptV2';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import { CHAT_THREAD, SPOTLIGHT } from 'conversations-visitor-experience-components/visitor-widget/constants/consentPromptVariants';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getUseSpotlightLauncher } from '../../widget-data/selectors/widgetDataSelectors';
import ConsentPromptWrapper from './ConsentPromptWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const ProcessConsentPrompt = ({
  closeConsentToProcess,
  consentToProcess,
  consentToProcessError,
  consentToProcessMessage,
  dismissConsentToProcessError = () => {},
  showGdprConsentToProcessButton = false,
  trackInteraction
}) => {
  const isAIChatBot = useSelector(getIsAIChatbot);
  const isSpotlight = useSelector(getUseSpotlightLauncher);
  const widgetColoring = useSelector(getColoring);
  useEffect(() => {
    trackInteraction === null || trackInteraction === void 0 || trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'view consent to process'
    });
  }, [trackInteraction]);
  const isPortal53 = getIsPortal53();
  if (consentToProcessError) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      $isPortal53: isPortal53,
      $isSpotlight: isSpotlight,
      children: /*#__PURE__*/_jsx(ChatAreaAlert, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.offline.title"
        }),
        onClose: dismissConsentToProcessError
      })
    });
  }
  if (isAIChatBot) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      $isPortal53: isPortal53,
      $isSpotlight: isSpotlight,
      children: /*#__PURE__*/_jsx(ConsentPromptV2, {
        variant: isSpotlight ? SPOTLIGHT : CHAT_THREAD,
        showConsentButton: showGdprConsentToProcessButton,
        consentMessage: consentToProcessMessage,
        onConsentAccept: consentToProcess,
        onClose: closeConsentToProcess,
        showDivider: false,
        isAIChatBot: isAIChatBot,
        accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor,
        isPortal53: isPortal53
      })
    });
  }
  return /*#__PURE__*/_jsx(ConsentPrompt, {
    showButton: showGdprConsentToProcessButton,
    message: consentToProcessMessage || '',
    onClick: consentToProcess || (() => {}),
    onClose: closeConsentToProcess,
    isPortal53: isPortal53
  });
};
ProcessConsentPrompt.displayName = 'ProcessConsentPrompt';
export default ProcessConsentPrompt;